const navLinks = [
  {
    pageName: "home",
    pageLink: "/",
  },
  {
    pageName: "menu",
    pageLink: "/menu",
  },
  {
    pageName: "faqs",
    pageLink: "/faqs",
  },
  {
    pageName: "contact",
    pageLink: "/contact",
  },
];

export default navLinks;
